import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Menu, X, ChevronRight } from 'lucide-react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Careers',
    href: '#careers'
  }, {
    name: 'Resources',
    href: '#resources'
  }, {
    name: 'Blog',
    href: '#blog'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={cn('fixed top-6 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-7xl transition-all duration-500 ease-in-out', isScrolled ? 'top-4 py-3 px-6 bg-white/80 backdrop-blur-xl border border-white/20 shadow-lg rounded-full' : 'py-5 px-8 bg-transparent')} data-id="element-218">
      <div className="flex items-center justify-between" data-id="element-219">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 group" data-id="element-220">
          <img src="https://www.harmonyhealthcaremd.com/wp-content/themes/harmonyhealthcarees376/images/main-logo.png" alt="Harmony Healthcare" className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105" data-id="element-221" />
        </a>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-222">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-dark-text hover:text-primary transition-colors duration-300 relative group" data-id="element-223">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" data-id="element-224" />
            </a>)}
        </div>

        {/* Right Side Actions */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-225">
          <a href="tel:240-468-4545" className="flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary-dark transition-colors" data-id="element-226">
            <div className="p-2 bg-primary/10 rounded-full" data-id="element-227">
              <Phone className="w-4 h-4" data-id="element-228" />
            </div>
            <span data-id="element-229">240-468-4545</span>
          </a>
          <button className="px-6 py-2.5 bg-primary text-white text-sm font-semibold rounded-full hover:bg-primary-dark transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0" data-id="element-230">
            Schedule Assessment
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden p-2 text-dark-text" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-231">
          {isMobileMenuOpen ? <X data-id="element-232" /> : <Menu data-id="element-233" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-234">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 mt-4 p-6 bg-white/95 backdrop-blur-2xl rounded-3xl border border-white/20 shadow-2xl lg:hidden" data-id="element-235">
            <div className="flex flex-col gap-4" data-id="element-236">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-dark-text hover:text-primary py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)} data-id="element-237">
                  {link.name}
                </a>)}
              <div className="mt-4 flex flex-col gap-4" data-id="element-238">
                <a href="tel:240-468-4545" className="flex items-center gap-3 text-primary font-semibold" data-id="element-239">
                  <Phone className="w-5 h-5" data-id="element-240" />
                  240-468-4545
                </a>
                <button className="w-full py-4 bg-primary text-white font-bold rounded-2xl shadow-lg" data-id="element-241">
                  Schedule Assessment
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}